import React, { useEffect } from "react";

const WcagTracker = () => {
  useEffect(() => {
    const html = document.documentElement;

    const setWcag = (method) => {
      html.setAttribute("data-input", method);
    };

    const handleClick = () => setWcag("mouse");
    const handleMouseMove = () => setWcag("mouse");
    const handleKeyDown = () => setWcag("key");

    document.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleKeyDown);
    document.getElementById("page-wrapper")?.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("keydown", handleKeyDown);
      document.getElementById("page-wrapper")?.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return null;
};

export default WcagTracker;
